const CxenseConfig = {
    fanpage: {
        networkId: "4732583558739624401",
        persistedQueryId: "b1e2a0cdd6d98413e40c8cda7860252baca60ffd",
    },
    geopop: {
        networkId: "4730331758378615146",
        persistedQueryId: "b1e2a0cdd6d98413e40c8cda7860252baca60ffd",
    },
    ck_it: {
        networkId: "4732583558739624402",
        persistedQueryId: "b1e2a0cdd6d98413e40c8cda7860252baca60ffd",
    },
    ck_wow: {
        networkId: "1353759740854645838",
        persistedQueryId: "b1e2a0cdd6d98413e40c8cda7860252baca60ffd",
    },
    kodami: {
        networkId: "4732583558739624401",
        persistedQueryId: "b1e2a0cdd6d98413e40c8cda7860252baca60ffd",
    },
};
export class Piano {
    win;
    product;
    cxConfig;
    constructor(win, product) {
        this.win = win;
        this.product = product;
        if (!this.win["_SiteConfig"] && !CxenseConfig[product]) {
            console.log("[PIANO] no cxense conf");
            return;
        }
        this.cxConfig =
            (this.win["_SiteConfig"] && this.win["_SiteConfig"].Cxense) ||
                CxenseConfig[product];
        console.log("[PIANO] initializing " + this.cxConfig.networkId);
    }
    init() {
        return new Promise((resolve, reject) => {
            if (!this.win["_SiteConfig"] && !CxenseConfig[this.product]) {
                resolve();
                return;
            }
            this.win.cX = this.win.cX || {};
            this.win.cX.callQueue = this.win.cX.callQueue || [];
            this.win.cX.callQueue.push(["setSiteId", this.cxConfig.networkId]);
            this.win.cX.callQueue.push(["sendPageViewEvent"]);
            const existingScript = this.win.document.querySelector('script[src="https://cdn.cxense.com/cx.js"]');
            if (existingScript) {
                console.log("[PIANO] cxense script già incluso");
                resolve();
                return;
            }
            const scriptElm = this.win.document.createElement("script");
            scriptElm.async = true;
            scriptElm.src = "https://cdn.cxense.com/cx.js";
            scriptElm.onload = () => {
                console.log("[PIANO] cxense script caricato");
                resolve();
            };
            scriptElm.onerror = () => {
                reject(new Error("Impossibile caricare lo script cxense"));
            };
            const firstScriptInDom = this.win.document.getElementsByTagName("script")[0];
            firstScriptInDom.parentNode.insertBefore(scriptElm, firstScriptInDom);
        });
    }
    setContextAndSegment(ids, onlyContextualIds) {
        if (ids && ids.length) {
            this.win.googletag.pubads().setTargeting("CxSegments", ids);
        }
        if (onlyContextualIds && onlyContextualIds.length) {
            this.win.googletag.pubads().setTargeting("CxContext", onlyContextualIds);
        }
    }
    getContextAndSegment() {
        return this.init().then(() => {
            return new Promise((resolve, reject) => {
                const cX = this.win.cX || {};
                console.log("[PIANO] cX:", JSON.stringify(cX));
                cX.callQueue = cX.callQueue || [];
                if (!this.cxConfig || !this.cxConfig.persistedQueryId) {
                    return reject(new Error("Persisted Query ID not found in configuration"));
                }
                cX.callQueue.push([
                    "invoke",
                    () => {
                        if (typeof cX.getSegments !== "function") {
                            return reject(new Error("cX.getSegments is not available"));
                        }
                        cX.getSegments(this.cxConfig.persistedQueryId, (segments) => {
                            console.log("[PIANO] segments:", segments);
                            if (!segments) {
                                return resolve({ ids: [], onlyContextualIds: [] });
                            }
                            const ids = [];
                            const onlyContextualIds = [];
                            segments.forEach((segment) => {
                                if (segment.type === "contextual") {
                                    onlyContextualIds.push(segment.id);
                                }
                                else {
                                    ids.push(segment.id);
                                }
                            });
                            console.log("[PIANO] contextual ids:", onlyContextualIds);
                            console.log("[PIANO] ids:", ids);
                            resolve({ ids, onlyContextualIds });
                        });
                    },
                ]);
            });
        });
    }
}
